import styled from 'styled-components';

export const SpeedWrapper = styled.div`
  margin: 10px;
  display: flex;
`;
